import RecipeLogStep, { type RecipeLogStepProps } from '../RecipeLogStep'

interface ReheatedStepProps extends Omit<RecipeLogStepProps, 'title' | 'description' | 'hint' | 'quantityKey' | 'logType' | 'showReason' | 'prefillValues' | 'prefillColumnLabel'> {
  storedYesterday?: Record<number, number>
}

const ReheatedStep = ({ storedYesterday, ...props }: ReheatedStepProps) => (
  <RecipeLogStep
    {...props}
    title="What was reheated this morning?"
    description="Log food that came out of cold storage and back into service today."
    hint="If stored food is no longer usable, log it as Expired in the Wasted & expired step instead."
    quantityKey="reheated_quantity"
    logType="reheated"
    prefillValues={storedYesterday}
    prefillColumnLabel="Stored last night"
  />
)

export default ReheatedStep
